<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="dataSource"
    :loading="loading"
    :pagination="false"
    row-key="key"
    size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Employee'">
        <div class="d-flex flex-column">
          <span class="fw-semibold">{{ record.employee_name }}</span>
          <span class="fs-12 text-muted">
            ID: {{ record.employee_id }} | {{ record.department || "-" }} /
            {{ record.designation || "-" }}
          </span>
        </div>
      </template>

      <template v-else-if="moneyColumns.includes(column.key)">
        {{ currency }}
        {{
          Number(record[column.dataIndex] || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })
        }}
      </template>
    </template>
  </a-table>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  currency: { type: String, default: "KES" },
});

const columns = [
  {
    title: "Employee",
    key: "Employee",
    dataIndex: "employee_name",
    sorter: (a, b) =>
      (a.employee_name || "").localeCompare(b.employee_name || ""),
  },
  {
    title: "KRA PIN",
    key: "KRA",
    dataIndex: "kra_pin",
  },
  {
    title: "NSSF No.",
    key: "NSSF",
    dataIndex: "nssf_number",
  },
  {
    title: "NHIF/SHIF No.",
    key: "NHIF",
    dataIndex: "nhif_number",
  },
  {
    title: "PAYE",
    key: "PAYE",
    dataIndex: "paye",
    sorter: (a, b) => (a.paye || 0) - (b.paye || 0),
  },
  {
    title: "NSSF",
    key: "NSSFAmount",
    dataIndex: "nssf",
    sorter: (a, b) => (a.nssf || 0) - (b.nssf || 0),
  },
  {
    title: "SHIF",
    key: "SHIF",
    dataIndex: "shif",
    sorter: (a, b) => (a.shif || 0) - (b.shif || 0),
  },
  {
    title: "Housing Levy (AHL)",
    key: "AHL",
    dataIndex: "ahl",
    sorter: (a, b) => (a.ahl || 0) - (b.ahl || 0),
  },
  {
    title: "Total Deductions",
    key: "TotalDeductions",
    dataIndex: "total_deductions",
    sorter: (a, b) => (a.total_deductions || 0) - (b.total_deductions || 0),
  },
  {
    title: "Gross",
    key: "Gross",
    dataIndex: "gross_salary",
    sorter: (a, b) => (a.gross_salary || 0) - (b.gross_salary || 0),
  },
  {
    title: "Net Pay",
    key: "NetPay",
    dataIndex: "net_pay",
    sorter: (a, b) => (a.net_pay || 0) - (b.net_pay || 0),
  },
];

const moneyColumns = [
  "PAYE",
  "NSSFAmount",
  "SHIF",
  "AHL",
  "TotalDeductions",
  "Gross",
  "NetPay",
];

const dataSource = computed(() =>
  (props.rows || []).map((r, idx) => ({
    key: idx,
    ...r,
  }))
);
</script>
